var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3996 1.53163C9.47104 1.37845 9.69303 1.37845 9.76447 1.53163L11.642 5.55757C11.8905 6.09042 12.397 6.45587 12.9796 6.52619L17.4048 7.06027C17.5781 7.08118 17.6379 7.28736 17.518 7.39833L14.2532 10.4206C13.8219 10.8198 13.6276 11.4138 13.7412 11.9912L14.5986 16.3472C14.6295 16.5042 14.4587 16.6418 14.3029 16.5556L10.4076 14.3975C9.89417 14.113 9.26989 14.113 8.75642 14.3975L4.86112 16.5556C4.70541 16.6418 4.53458 16.5042 4.56548 16.3472L5.42287 11.9912C5.5365 11.4138 5.34217 10.8198 4.91085 10.4206L1.64604 7.39833C1.52616 7.28735 1.58596 7.08118 1.75926 7.06027L6.18444 6.52619C6.76711 6.45587 7.27357 6.09042 7.52207 5.55757L9.3996 1.53163Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartWhite);
export default __webpack_public_path__ + "static/media/start-white.389f8dcd64fa6fe97f68f865e7a8f737.svg";
export { ForwardRef as ReactComponent };